import React from "react";
import ReactDOM from "react-dom";

function IframeModal({ url, isOpen, onClose }: any) {
  if (!isOpen) return null;

  const uniqueUrl = `${url}?v=${new Date().getTime()}`;

  return ReactDOM.createPortal(
    <div className="min-h-screen h-full w-full z-[99999] md:p-10 p-8 fixed top-0 left-0 bg-black/50">
      <div className="modal h-full relative">
        <button
          onClick={() => {
            onClose(false);
          }}
          className="absolute z-50 cursor-pointer md:right-5 -right-6 -top-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={4}
            stroke="currentColor"
            className="w-6 h-6 text-white font-extrabold"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="modal-content h-full max-w-7xl mx-auto w-full">
          <iframe
            src={uniqueUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>,
    document.getElementById("modal-root") as HTMLElement
  );
}

export default IframeModal;
